import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import {
  businessQuery,
  datamodelMutation,
  datamodelsQuery,
  groupsQuery,
} from '@queries';
import { ChevronRightIcon } from '@svgs';

import { DataModelForm } from '../components/DataModelForm/DataModelForm.jsx';
import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';

export const AddDataModel = () => {
  const { t, i18n } = useTranslation();
  const { businessID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get groups
  const { data: groupsData, isPending: groupsIsPending } =
    useQuery(groupsQuery());

  // get datamodels
  const { data: datamodelsData, isPending: datamodelsIsPending } = useQuery(
    datamodelsQuery({
      order_by: 'name',
    }),
  );

  // save datamodel
  const mutation = useMutation(
    datamodelMutation(null, {
      onSuccess: (data) => {
        // invalidate list views so they are re-fetched
        queryClient.invalidateQueries({ queryKey: ['datamodels', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/projects/${businessID}/datamodels/${data.id}`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <Link to={`/dashboard/projects/${businessID}/datamodels`}>
                Manage fields
              </Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">Add</li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            {(groupsIsPending || datamodelsIsPending) && (
              <>
                <h1>Add</h1>
                <Loader className="sb-loader sb-loader-large" />
              </>
            )}
            {!groupsIsPending && !datamodelsIsPending && (
              <>
                <h1>Add</h1>
                <DataModelForm
                  datamodelData={{}}
                  datamodelsData={datamodelsData}
                  disabled={mutation.isPending}
                  mutation={mutation}
                  groupsData={groupsData}
                />
              </>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
